import { render, staticRenderFns } from "./ShowMaterialBankFiles.vue?vue&type=template&id=91f5c238&scoped=true&"
import script from "./ShowMaterialBankFiles.vue?vue&type=script&lang=js&"
export * from "./ShowMaterialBankFiles.vue?vue&type=script&lang=js&"
import style0 from "./ShowMaterialBankFiles.vue?vue&type=style&index=0&id=91f5c238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f5c238",
  null
  
)

export default component.exports